import { Platform, StatusBar, Dimensions } from 'react-native';

const width = Dimensions.get('screen').width;
const height = Dimensions.get('screen').height;

export const StatusHeight = StatusBar.currentHeight;
export const HeaderHeight = (13 * 4 + StatusHeight);
export const iPhoneX = () => Platform.OS === 'ios' && (height === 812 || width === 812);